import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { TrxPaymodeData } from '../core/_models'
import { getTrxPaymode } from '../core/_requests'
import { ID } from '@/_metronic/helpers'
import { DonutCard } from './DonutCard'

const getColor = (paymode: string | null) => {
  switch (paymode) {
    case 'dcb':
      return 'danger'
    case 'premium-calling':
      return 'primary'
    case 'premium-text-message':
      return 'info'
    default:
      return 'warning'
  }
}

type Props = {
  userId?: ID
  from: Date
  to: Date
  height: number
  timezone: string;
}

const TrxPaymodeChart = ({ userId, from, to, height, timezone }: Props) => {
  const intl = useIntl()
  const [data, setData] = useState<TrxPaymodeData[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true)
        const res = await getTrxPaymode({ from, to, userId, timezone })
        setData(res || [])
      } catch (e) {
        console.error(e)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [userId, from, to])

  return (
    <DonutCard<TrxPaymodeData>
      id="paymodes"
      title="Payment modes"
      height={height}
      isLoading={isLoading}
      data={data}
      showAggs={true}
      getLabel={(item) =>
        intl.formatMessage({
          id: `P2C.PAYMODE_${(item.type || 'Unknown').toUpperCase()}`,
        })
      }
      getColorClass={(item) => getColor(item.type)}
      getAggValue={(item, agg) => Number(item[agg as keyof TrxPaymodeData]) || 0}
    />
  )
}

export default TrxPaymodeChart
